module.exports = __webpack_public_path__ + "static/forbes-57fdee772423f96d9d2e003af843e858.svg";